import { palette } from 'src/styles/colors';
import { layout } from 'src/styles/layout';
import styled from 'styled-components';

export const CreatorTestemonyContainer = styled.div`
  max-width: 100vw !important;
  margin: 0 auto;
  background-color: ${palette.black};
  min-height: 1100px;
  position: relative;

  @media screen and (max-width: ${layout.subLg}) {
    min-height: unset;
  }
`

export const CreatorTestemonyContent = styled.div`
  max-width: 1920px;
  margin: 0 auto;
  display: grid;
  position: relative;
  padding: 13.25rem 0 3.875rem;

  @media screen and (max-width: ${layout.subLg}) {
    padding-top: 7.5rem;
  }

  @media screen and (max-width: ${layout.sm}) {
    padding: 1.875rem 0 0;
    display: grid;
  }
`

export const TestemonyCard = styled.div`
  display: grid;
  position: absolute;
  left: 0;
  bottom: 212px;
  min-height: 400px;
  min-width: 43%;
  background: ${palette.engagementDropLinkText};
  box-sizing: border-box;

  @media screen and (max-width: ${layout.lg}) {
    min-height: unset;
  }

  @media screen and (max-width: ${layout.subLg}) {
    bottom: 120px;
  }

  @media screen and (max-width: ${layout.sm}) {
    position: relative;
    width: 100%;
    padding: 2rem 3.2rem 4rem;
    bottom: 0;
  }
`

export const TestemonyCardContent = styled.div`
  box-sizing: border-box;
  padding: 3.1rem 1.7rem 3.1rem 5rem;
  max-width: 650px;
  justify-self: right;
  align-items: center;
  margin-left: auto;
  display: grid;
  grid-row-gap: 2.1rem;

  @media screen and (max-width: ${layout.subMd}) {
    max-width: 500px;
  }

  @media screen and (max-width: ${layout.sm}) {
    padding: 0;

    p, > div h1 {
      text-align: center;
    }
  }
`

export const CreatorContent = styled.div`
  max-width: 1540px;
  width: 100%;
  margin: 0 auto;
  display: grid;
  box-sizing: border-box;
  padding: 0 70px;

  > h1 {
    max-width: 800px;
  }

  > div {
    justify-self: right;
    margin-right: -220px;
    margin-top: -60px;
    width: 100%;
    max-width: 1100px;
  }

  @media screen and (max-width: ${layout.subLg}) {
    > div {
      margin-top: 0;
      margin-bottom: 3.75rem;
    }
  }

  @media screen and (max-width: ${layout.sm}) {
    padding: 0;

    h1 {
      max-width: 265px;
      margin: 0 auto;
      text-align: center;
      line-height: 2rem;
      padding: 2.5rem;
    }

    > div {
      margin: 0;
      width: 130%;
      transform: translateX(10%);
      margin-bottom: -16px;
    }
  }
`

export const BottomGradient = styled.div`
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
  height: 260px;
  background: linear-gradient(180deg, rgba(0, 0, 0, 0) 0%, #000000 57.92%);

  @media screen and (max-width: ${layout.subLg}) {
    height: 200px;
  }

  @media screen and (max-width: ${layout.sm}) {
    display: none;
  }
`
